<template>
  <div class="count-container">
    <h1>APP数据</h1>
  </div>
</template>

<script>
    export default {
        name: "appCount"
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// appCount.vue?7d23344c